import React from 'react';
import { Button } from '@/Components/ui/button';
import { Inline } from '@/Components/ui/layout';

function Header() {
  function logout() {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  
  return (
    <header className="border-b border-border flex w-full items-center justify-between flex-wrap text-foreground font-semibold text-xl">
      <img 
        className="aspect-[4.39] object-contain w-[219px] my-auto" 
        src="/Newzenalphablue.png" 
        alt="Logo" 
      />
      <Button 
        variant="outline" 
        className="rounded-lg border border-foreground px-5 py-2.5 bg-transparent text-foreground font-semibold text-xl cursor-pointer"
        onClick={logout}
      >
        Sign Out
      </Button>
    </header>
  );
}

export default Header;
